import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 28 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "search-mobile-bar__icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.7771 10.8886C21.7771 16.9023 16.9021 21.7773 10.8885 21.7773C4.87497 21.7773 0 16.9023 0 10.8886C0 4.87501 4.87497 0 10.8885 0C16.9021 0 21.7771 4.87501 21.7771 10.8886ZM3.26656 10.8886C3.26656 15.0982 6.67904 18.5107 10.8885 18.5107C15.098 18.5107 18.5105 15.0982 18.5105 10.8886C18.5105 6.6791 15.098 3.26659 10.8885 3.26659C6.67904 3.26659 3.26656 6.6791 3.26656 10.8886Z",
    fill: "#9aa5b4"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "2.90362",
    height: "13.0663",
    rx: "1.45181",
    transform: "matrix(0.707104 -0.70711 0.707104 0.70711 15.9395 17.2969)",
    fill: "#9aa5b4"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "search-mobile-bar__placeholder" }, "Поиск по ИНН, ОГРН, Названию...", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = {
  key: 2,
  width: "28",
  height: "27",
  viewBox: "0 0 28 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.7771 10.8886C21.7771 16.9023 16.9021 21.7773 10.8885 21.7773C4.87497 21.7773 0 16.9023 0 10.8886C0 4.87501 4.87497 0 10.8885 0C16.9021 0 21.7771 4.87501 21.7771 10.8886ZM3.26656 10.8886C3.26656 15.0982 6.67904 18.5107 10.8885 18.5107C15.098 18.5107 18.5105 15.0982 18.5105 10.8886C18.5105 6.6791 15.098 3.26659 10.8885 3.26659C6.67904 3.26659 3.26656 6.6791 3.26656 10.8886Z",
  fill: "#0066CE"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.90362",
  height: "13.0663",
  rx: "1.45181",
  transform: "matrix(0.707104 -0.70711 0.707104 0.70711 15.9395 17.2969)",
  fill: "#0066CE"
}, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "list-group position-absolute"
}
const _hoisted_9 = {
  key: 0,
  class: "search-type"
}
const _hoisted_10 = {
  key: 0,
  class: "list-group-item search-access-denied"
}
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "list-group-item search-empty"
}
const _hoisted_14 = {
  key: 2,
  class: "list-group-item search-loading"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "loader mx-auto" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "search-modal" }
const _hoisted_18 = { class: "search-modal__header" }
const _hoisted_19 = { class: "search-modal__input-wrap" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 28 27",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.7771 10.8886C21.7771 16.9023 16.9021 21.7773 10.8885 21.7773C4.87497 21.7773 0 16.9023 0 10.8886C0 4.87501 4.87497 0 10.8885 0C16.9021 0 21.7771 4.87501 21.7771 10.8886ZM3.26656 10.8886C3.26656 15.0982 6.67904 18.5107 10.8885 18.5107C15.098 18.5107 18.5105 15.0982 18.5105 10.8886C18.5105 6.6791 15.098 3.26659 10.8885 3.26659C6.67904 3.26659 3.26656 6.6791 3.26656 10.8886Z",
    fill: "#9aa5b4"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "2.90362",
    height: "13.0663",
    rx: "1.45181",
    transform: "matrix(0.707104 -0.70711 0.707104 0.70711 15.9395 17.2969)",
    fill: "#9aa5b4"
  })
], -1)
const _hoisted_21 = { class: "search-modal__results" }
const _hoisted_22 = {
  key: 0,
  class: "search-type"
}
const _hoisted_23 = {
  key: 0,
  class: "search-modal__access-denied"
}
const _hoisted_24 = { class: "search-modal__access-title" }
const _hoisted_25 = { class: "search-modal__access-text" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "search-modal__item-name" }
const _hoisted_28 = { class: "search-modal__item-meta" }
const _hoisted_29 = {
  key: 2,
  class: "search-modal__empty"
}
const _hoisted_30 = {
  key: 1,
  class: "search-modal__loading"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "loader mx-auto" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "search-modal__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-box d-md-flex", { 'input-box--mobile-trigger': _ctx.isMobile }])
    }, [
      (!_ctx.isMobile)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            type: "text",
            class: "form-control",
            placeholder: "Поиск компании по ИНН, ОГРН, Названию или ОКВЭД",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = true))
          }, null, 544)), [
            [_vModelText, _ctx.searchQuery]
          ])
        : _createCommentVNode("", true),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "search-mobile-bar",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openMobileModal && _ctx.openMobileModal(...args)))
          }, _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_7))
        : _createCommentVNode("", true),
      (!_ctx.isMobile && _ctx.searchQuery && _ctx.isFocused)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_ctx.searchResultsIP.length && _ctx.searchResultsINN.length)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createTextVNode(" Искать по: "),
                  _createElementVNode("button", {
                    class: _normalizeClass([{ select: _ctx.selectMode === 'inn' || _ctx.selectMode === 'start' }, "ms-2 btn-small"]),
                    onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectMode = 'inn'), ["prevent"]))
                  }, " Компаниям ", 34),
                  _createElementVNode("button", {
                    class: _normalizeClass([{ select: _ctx.selectMode === 'ip' }, "ms-4 btn-small"]),
                    onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.selectMode = 'ip'), ["prevent"]))
                  }, " ИП ", 34)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.accessDeniedStatus)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.accessDeniedTitle), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.accessDeniedDescription), 1),
                        (_ctx.accessDeniedStatus === 401)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "search-access-denied__action",
                              onMousedown: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAuthModal && _ctx.openAuthModal(...args)), ["prevent"]))
                            }, " Войти ", 32))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "search-access-denied__action",
                              onMousedown: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToPricing && _ctx.goToPricing(...args)), ["prevent"]))
                            }, " Перейти к тарифам ", 32))
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSearchResults, (company) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: _ctx.getCompanyId(company),
                            class: "list-group-item",
                            onMousedown: _withModifiers(($event: any) => (_ctx.goToCompany(_ctx.getCompanyId(company))), ["prevent"])
                          }, [
                            _createElementVNode("h5", null, _toDisplayString(_ctx.getCompanyName(company)), 1),
                            (_ctx.getCompanyMeta(company))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.getCompanyMeta(company)), 1))
                              : _createCommentVNode("", true)
                          ], 40, _hoisted_11))
                        }), 128)),
                        (!_ctx.visibleSearchResults.length)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13, "Ничего не найдено"))
                          : _createCommentVNode("", true)
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock("li", _hoisted_14, _hoisted_16))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isMobile && _ctx.mobileModalOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "search-modal-overlay",
            onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeMobileModal && _ctx.closeMobileModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    ref: "mobileInput",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    class: "search-modal__input",
                    placeholder: "ИНН, ОГРН, Название...",
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  (_ctx.searchQuery)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "search-modal__clear",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchQuery = ''))
                      }, "✕"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  class: "search-modal__cancel",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeMobileModal && _ctx.closeMobileModal(...args)))
                }, "Отмена")
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_ctx.searchQuery && _ctx.searchResultsIP.length > 0 && _ctx.searchResultsINN.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createTextVNode(" Искать по: "),
                      _createElementVNode("button", {
                        class: _normalizeClass([{ select: _ctx.selectMode === 'inn' || _ctx.selectMode === 'start' }, "ms-2 btn-small"]),
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectMode = 'inn'))
                      }, " Компаниям ", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass([{ select: _ctx.selectMode === 'ip' }, "ms-4 btn-small"]),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectMode = 'ip'))
                      }, " ИП ", 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.searchQuery)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.accessDeniedStatus)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.accessDeniedTitle), 1),
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.accessDeniedDescription), 1),
                                  (_ctx.accessDeniedStatus === 401)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "search-modal__access-action",
                                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openAuthModal && _ctx.openAuthModal(...args)))
                                      }, " Войти "))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "search-modal__access-action",
                                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goToPricing && _ctx.goToPricing(...args)))
                                      }, "Перейти к тарифам"))
                                ]))
                              : (_ctx.searchResultsINN.length || _ctx.searchResultsIP.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visibleSearchResults, (company) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: _ctx.getCompanyId(company),
                                      class: "search-modal__item",
                                      onClick: ($event: any) => (_ctx.goToCompany(_ctx.getCompanyId(company)))
                                    }, [
                                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getCompanyName(company)), 1),
                                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getCompanyMeta(company)), 1)
                                    ], 8, _hoisted_26))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("div", _hoisted_29, "Ничего не найдено"))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, "Введите ИНН, ОГРН или название компании"))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}